export default "__VITE_ASSET__igdysZJC__"